import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquareIcon, PhoneIcon } from 'lucide-react';
import { CONTACT } from '../../data/modalities';
export function FinalCTA() {
  return <section className="w-full bg-green-deep py-20 text-white sm:py-24" data-id="element-172" data-mp="3mu1umcf8fefh">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-8" data-id="element-173" data-mp="3mrxoroxrw5ck">
        <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-[2.6rem]" data-id="element-174" data-mp="3rraau7gtl8e3">
          Before You Buy Another Modality, Call JAG.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[16px] leading-relaxed text-white/75" data-id="element-175" data-mp="3huxhjap6swjv">
          Get a clearer view of what fits your patients, your team, and your
          practice goals.
        </p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-176" data-mp="38v22gusighek">
          <a href={CONTACT.phoneHref} className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-teal px-8 py-4 text-[15px] font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white sm:w-auto" data-id="element-177" data-mp="1239pntp15u7x">
            <PhoneIcon className="h-[18px] w-[18px]" data-id="element-178" data-mp="l90u8domzrq6" />
            Call {CONTACT.phone}
          </a>
          <Link to="/contact" className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/25 px-8 py-4 text-[15px] font-semibold text-white transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white sm:w-auto" data-id="element-179" data-mp="z0fhiwpkuf31">
            <MessageSquareIcon className="h-[18px] w-[18px]" data-id="element-180" data-mp="gafu0e9dx81q" />
            Send a Message
          </Link>
        </div>
      </div>
    </section>;
}